import { render, staticRenderFns } from "./Bolla-Details.vue?vue&type=template&id=3f2d014e&scoped=true&"
import script from "./Bolla-Details.vue?vue&type=script&lang=js&"
export * from "./Bolla-Details.vue?vue&type=script&lang=js&"
import style0 from "./Bolla-Details.vue?vue&type=style&index=0&id=3f2d014e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d014e",
  null
  
)

export default component.exports